<template lang="">
  <div class="h-error-page">
    <font-icon
      class="icon"
      icon="fa-solid fa-circle-exclamation"
      size="3x"
    />
    <h1 class="status">
      {{ status }}
    </h1>
    <p>
      {{ message }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'HError',
  props: {
    status: {
      type: String,
      default: 'Unknwon'
    },
    message: {
      type: String,
      default: '未預期錯誤'
    }
  }
}
</script>
<style lang="scss" scoped>
.h-error-page {
  text-align: center;
  width: 100%;
}
.icon {
  color: color(red-3);
  margin-top: 40px;
  margin-bottom: 20px;
}
.status {
  font-size: 32px;
  font-weight: bold;
  color: color(red-3);
  margin-bottom: 20px;
}
</style>